import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ListingsScreen from "../screens/ListingsScreen";
import ListingDetailsScreen from "../screens/ListingDetailsScreen";
import SearchUserScreen from "../screens/SearchUserScreen";
import FoundUserScreen from "../screens/FoundUserScreen";
import FollowersScreen from "../screens/FollowersScreen";
import FollowedScreen from "../screens/FollowedScreen";
import ListingUsersLikePublication from "../screens/ListingUsersLikePublication";
import CommentsPublicationScreen from "../screens/CommentsPublicationScreen";
import ListingsSeedsScreen from "../screens/ListingsSeedsScreen";
import ListingDetailsSeedScreen from "../screens/ListingDetailsSeedScreen";
import ActionScreen from "../screens/ActionScreen";
import CommentsSeedScreen from "../screens/CommentsSeedScreen";
import ChatUserListScreen from "../screens/ChatUserListScreen";
import ChatScreen from "../screens/ChatScreen";
import ViewImageScreen from "../screens/ViewImageScreen";

const Stack = createStackNavigator();

const SearchUserNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="Search" component={SearchUserScreen}   />
    <Stack.Screen name="FoundUser" component={FoundUserScreen}  />
    <Stack.Screen name="Followers" component={FollowersScreen} />
    <Stack.Screen name="Followed" component={FollowedScreen} />
    <Stack.Screen name="Listing" component={ListingsScreen} />
    <Stack.Screen name="ListingDetails" component={ListingDetailsScreen} />
    <Stack.Screen name="ListingLikePublication" component={ListingUsersLikePublication} />
    <Stack.Screen name="CommentsPublication" component={CommentsPublicationScreen} />
    <Stack.Screen name="Listings Seed" component={ListingsSeedsScreen} />
    <Stack.Screen name="Seed Details" component={ListingDetailsSeedScreen} />
    <Stack.Screen name="AddAction" component={ActionScreen} />
    <Stack.Screen name="Comments Seeds" component={CommentsSeedScreen} />
    <Stack.Screen name="Chat List" component={ChatUserListScreen} />
    <Stack.Screen name="Chat" component={ChatScreen} />
    <Stack.Screen name="ViewImage" component={ViewImageScreen} options={{ tabBarVisible: false, headerShown: false}} />

  </Stack.Navigator>
);

export default SearchUserNavigator;